export enum Language {
  EnglishGB = 'en-GB',
  German = 'de-DE',
}
